export type PhoneNumberCountry = 'PL' | 'HR' | 'SK' | 'BG' | 'TR' | 'CZ' | 'OTHER'

export enum EPHONE_CODES {
  POLAND = 'PL',
  TURKEY = 'TR',
  BULGARIA = 'BG',
  CROATIA = 'HR',
  CZECH_REPUBLIC = 'CZ',
  SLOVAKIA = 'SK',
  OTHER = 'OTHER',
}

export enum EPHONE_PREFIXES {
  POLAND = '+48',
  TURKEY = '+90',
  BULGARIA = '+359',
  CROATIA = '+385',
  CZECH_REPUBLIC = '+420',
  SLOVAKIA = '+421'
}
